import {County} from "@apps/Shared/Types/County";

export const mapCountyFromMaps = (county: string) => {
    if (county.includes('Stockholm')) {
        return County.Stockholm
    } else if (county.includes('Uppsala')) {
        return County.Uppsala
    } else if (county.includes('Södermanland')) {
        return County.Sodermanland
    } else if (county.includes('Östergötland')) {
        return County.Ostergotland
    } else if (county.includes('Jönköping')) {
        return County.Jonkoping
    } else if (county.includes('Kronoberg')) {
        return County.Kronoberg
    } else if (county.includes('Kalmar')) {
        return County.Kalmar
    } else if (county.includes('Gotland')) {
        return County.Gotland
    } else if (county.includes('Blekinge')) {
        return County.Blekinge
    } else if (county.includes('Skåne')) {
        return County.Skane
    } else if (county.includes('Halland')) {
        return County.Halland
    } else if (county.includes('Götalands')) {
        return County.VastraGotaland
    } else if (county.includes('Värmland')) {
        return County.Varmland
    } else if (county.includes('Örebro')) {
        return County.Orebro
    } else if (county.includes('Västmanland')) {
        return County.Vastmanland
    } else if (county.includes('Dalarna')) {
        return County.Dalarna
    } else if (county.includes('Gävleborg')) {
        return County.Gavleborg
    } else if (county.includes('Västernorrland')) {
        return County.Vasternorrland
    } else if (county.includes('Jämtland')) {
        return County.Jamtland
    } else if (county.includes('Västerbotten')) {
        return County.Vasterbotten
    } else if (county.includes('Norrbotten')) {
        return County.Norrbotten
    } else {
        return County.All
    }
}
